// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleBindingApi } from './moduleBindingApi';
import type { TaskBindingApi } from './taskBindingApi';

/**
 * Slot binding configuration for API requests (inherits shared schema).
 */
export interface SlotBindingRequest {
  moduleBindings?: ModuleBindingApi[];
  taskBindings?: TaskBindingApi[];
}
